import { EMPTY } from 'rxjs';
import { withLatestFrom, mergeMap } from 'rxjs/operators';
import { replace } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '@cbridge-packages/routing';
import { getDetailsFromLocationState } from '../_helpers/getDetailsFromLocationState';
import { DetailsSidebarAction } from '../detailsSidebar.action';
import { detailsSidebarStoreSelector } from '../detailsSidebar.selector';
import { SidebarOpenMode } from '../detailsSidebar.interface';

type IState =
  & IGetSelectorStateType<typeof detailsSidebarStoreSelector>
  & IGetSelectorStateType<typeof locationSelector>;

export const linkToggleEditWithLocationEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(DetailsSidebarAction.toggleEdit),
  withLatestFrom(state$),
  mergeMap(([, state]) => {
    const { id, mode } = detailsSidebarStoreSelector(state);
    const location = locationSelector(state);

    if (id !== undefined && (mode === SidebarOpenMode.View || mode === SidebarOpenMode.Edit)) {
      const state = getDetailsFromLocationState(location.state);
      return [
        replace(location, {
          ...state,
          mode,
        }),
      ];
    }

    return EMPTY;
  }),
);
